// extracted by mini-css-extract-plugin
export default {"trainers":"trainers_trainers__s-TW+","trainers_head":"trainers_trainers_head__YhTgL","boxes":"trainers_boxes__S8877","box":"trainers_box__Psnvm"};